import ClientSaveButtons from '@/containers/SubscriptionFormPageNew/Components/SaveButtons/ClientSaveButtons'

/**
 * TopHeader displayed at the top of the 'client' tab. Mirrors the contract
 * TopHeader layout (full-width row, save button anchored top-right).
 */
const ClientTopHeader = () => {
  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
      }}
    >
      <ClientSaveButtons />
    </div>
  )
}

export default ClientTopHeader
